package api

import kotlinx.serialization.Serializable

@Serializable
data class Login(val number: String, val code: String, val placeCode: String)
